import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = (values) => {
  return axios.get(API_URL + "users-group", {
    headers: authHeader(),
    params: values,
  });
};

const create = (values) => {
  return axios.post(API_URL + "users-group/create", values, {
    headers: authHeader(),
  });
};
const update = (values) => {
  return axios.post(API_URL + "users-group/update", values, {
    headers: authHeader(),
  });
};
const destroy = (values) => {
  return axios.post(API_URL + "users-group/destroy", values, {
    headers: authHeader(),
  });
};

const userGroupService = { list, create, update, destroy };

export default userGroupService;
